import React, { Component } from 'react';
import PropTypes from 'prop-types';
import clearSortIcon from '../../images/insight360/clear-field-icon_white.png';
import { ALL } from '../../constants';

export default class ReportSort extends Component {

  applyReportSort = (sortType, sortBy) => {
    this.props.sortReportChart({
      index: this.props.index,
      type: sortType,
      sortBy,
    });
  };

  hideSortDropdown = () => {
    this.props.sortReportChart();
  };

  render() {
    return (
      <div className="position-relative reportPdfflag">
        <button
          type="button"
          className="margin-right-5"
          style={{ display: this.props.enableSortArrow ? 'block' : 'none' }}
          title="Sort"
          onClick={this.props.btnClickFn}
        >
          {String.fromCharCode(9660)}
        </button>
        <div
          className={`i360-report-sort-dropdown ${
            this.props.selectedRef === this.props.index ? 'active' : ''
          }`}
        >
          <div className="sort-dropdown-header">
            <span>Sort</span>
            <button
              onClick={() => this.hideSortDropdown()}
              className="insight360_header_icons_img"
            >
              <img src={clearSortIcon} alt="sort" />
            </button>
          </div>
          {this.props.displaySortOption == 'all' &&
            <ul className="sort-dropdown-content">
              <li>
                <button type="button" onClick={() => this.applyReportSort('asc', 'Index')}>Index Ascending</button>
              </li>
              <li>
                <button type="button" onClick={() => this.applyReportSort('desc', 'Index')}>Index Descending</button>
              </li>
              <li>
                <button type="button" onClick={() => this.applyReportSort('asc', 'Percent')}>Percent Ascending</button>
              </li>
              <li>
                <button type="button" onClick={() => this.applyReportSort('desc', 'Percent')}>Percent Descending</button>
              </li>
            </ul>
          }
          {this.props.displaySortOption === 'Index' &&
            <ul className="sort-dropdown-content">
              <li>
                <button type="button" onClick={() => this.applyReportSort('asc', 'Index')}>Index Ascending</button>
              </li>
              <li>
                <button type="button" onClick={() => this.applyReportSort('desc', 'Index')}>Index Descending</button>
              </li>
            </ul>
          }
           {this.props.displaySortOption === 'pct' &&
            <ul className="sort-dropdown-content">
              <li>
                <button type="button" onClick={() => this.applyReportSort('asc', 'Percent')}>Reach Ascending</button>
              </li>
              <li>
                <button type="button" onClick={() => this.applyReportSort('desc', 'Percent')}>Reach Descending</button>
              </li>
            </ul>
          }
        </div>
      </div>
    );
  }
}

ReportSort.defaultProps = {
  // hidePercentageSort: false,
  displaySortOption: 'all',
};

ReportSort.propTypes = {
  hidePercentageSort: PropTypes.bool,
};
